import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from './api';
import { Container, Box, Typography, TextField, Button } from '@mui/material';

function ResetPasswordPage() {
  const { token } = useParams(); // Get the secret token from the URL
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    document.title = "Reset Password | Christmas Lights Map";
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');

    if (password !== confirm) {
      setError("Passwords do not match");
      return;
    }

    try {
      const res = await api.post('/reset-password', { 
        token: token, 
        newPassword: password 
      });
      setMessage(res.data.message);
      // Redirect to login after 3 seconds so they can read the success message
      setTimeout(() => navigate('/login'), 3000); 
    } catch (err) {
      setError(err.response?.data?.message || "Error resetting password.");
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>Reset Password</Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Confirm Password"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
          <Button type="submit" fullWidth variant="contained" sx={{ mt: 3 }}>
            Reset Password
          </Button>
        </form>
        
        {message && <Typography sx={{ mt: 2 }} color="primary">{message}</Typography>}
        {error && <Typography sx={{ mt: 2 }} color="error">{error}</Typography>}
      </Box>
    </Container>
  );
}

export default ResetPasswordPage;